<div class="modal-header border-0">
  <div>
    <p class="fs-20 fw-800 color-gray-950 mb-0">{{'agenda.all_requests_title'|translate}}</p>
    <p class="fs-small fw-400 color-gray-400 mb-0">{{'agenda.all_requests_desc'|translate}}</p>
  </div>

  <a class="clickable color-gray-400" (click)="modal.dismiss()"
     [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
</div>

<div class="modal-body pt-0">
  <ngx-skeleton-loader
    *ngIf="isLoading && !requests.length" count="3" appearance="line"
    [theme]="{height: '80px', 'border-radius': '12px', margin: '0 0 8px 0'}"/>

  <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!isLoading && !requests.length">
    {{'agenda.no_reschedule_request'|translate}}
  </p>

  <coach-reschedule-request-row
    class="d-block mb-2" *ngFor="let request of requests"
    [request]="request" [showStatus]="true" [isBusy]="busyRequestId === request.id"
    (approveRequested)="approve($event)"
    (rejectRequested)="reject($event)"></coach-reschedule-request-row>

  <div class="text-center mt-3" *ngIf="hasMore()">
    <app-gray-button
      color="stroke-gray" [fullWidth]="false" padding="px-3 py-2" [weight]="800"
      customClass="fs-small border-8"
      [isLoading]="isLoading" [disabled]="isLoading"
      [text]="'agenda.load_more_requests'|translate"
      (click)="loadMore()"></app-gray-button>
  </div>
</div>
